<template>
	<div class="uupay-container">

    <section class="modules-section">
      <div class="container modules-section-container">
        <div class="content my-4">
          <div class="row">
            <div class="col-md-12">
              <router-link to="/blog">
                <div class="back d-flex align-items-center">
                  <div class="mr-2"><img src="@/assets/uupay/icon/svg/wonder_blog_arrow_left.svg" class="img-fluid"></div>
                  <div>返回商戶成功案例</div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="container modules-section-container">
        <div class="content my-4">
          <div class="row">
            <div class="col-md-4">
              <div class="title">
                個體分析
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-8">
              <div class="business-content d-flex">
                <div class="d-flex">
                  <div class="mr-4" v-for="(item, index) in blogKinds">
                    <button class="business" :class="index == activeIndex ? 'business-selected': ''" @click="handleKind(index)">{{ item }}</button>
                  </div>
                </div>
                
              </div>
            </div>
          </div>

          <div class="row g-2 my-4">
            <div class="col-md-4" v-for="item in blogs">
              <div class="mb-5">
                <blog-card
                  :imageUrl="item.imageUrl"
                  :title="item.title"
                  :date="item.date"
                  :link="{ name: 'BlogDetail', params: { id: item.id } }"
                />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="d-flex justify-content-center">
                <el-pagination
                  class="custom-pagination"
                  layout="prev, pager, next"
                  :page-size.sync="page.pageSize"
                  :total="page.total"
                  @current-change="handlePageChange"
                >
                </el-pagination>
              </div>
            </div>
          </div>

        </div>
      </div>

    </section>
    
  </div>
</template>
<script>
import BlogCard from "@/components/BlogCard";

export default {
  name: 'MerchantCase',
  components: {
    BlogCard
  },
  data() {
    return {
      activeIndex: 0,
      blogKinds: ['全部', '飲食類', '服務類'],
      blogs: [
        {id: 0,  imageUrl: this.getImage('merchant_feature_1'),  date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 1,  imageUrl: this.getImage('merchant_feature_2'),  date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 2,  imageUrl: this.getImage('merchant_feature_3'),  date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 3,  imageUrl: this.getImage('merchant_feature_4'),  date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 4,  imageUrl: this.getImage('merchant_feature_5'),  date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 5,  imageUrl: this.getImage('merchant_feature_6'),  date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 6,  imageUrl: this.getImage('merchant_feature_7'),  date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 7,  imageUrl: this.getImage('merchant_feature_8'),  date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 8,  imageUrl: this.getImage('merchant_feature_9'),  date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 9,  imageUrl: this.getImage('merchant_feature_10'), date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 10, imageUrl: this.getImage('merchant_feature_11'), date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
        {id: 11, imageUrl: this.getImage('merchant_feature_12'), date: '16/12/2025', title: '中小企必看｜Digital 2025香港報告出爐！超過8成港人活躍於社交平台 附實用營商建議', },
      ],
      page: {
        total: 6,
        pageSize: 4,
      }
    }
  },
  methods: {
    // 示例：跳转到指定幻灯片
    goToSlide(index) {
      this.$refs.banner.slideTo(index)
    },
    
    // 示例：暂停自动播放
    pauseBanner() {
      this.$refs.banner.stopAutoplay()
    },
    getImage(name) {
      return require(`@/assets/uupay/images/${name}.png`)
    },
    // 示例：恢复自动播放
    resumeBanner() {
      this.$refs.banner.startAutoplay()
    },
    handleKind(index) {
      this.activeIndex = index
    },
    handlePageChange(page) {
      console.log('handlePageChange:', page)
    }
  },
  
}
</script>
<style scoped>


.modules-section {
  padding: 2rem 0;
  color: #21042e;
  background-color: #f8f8f8;
}

.modules-section .back {
  font-size: 20px;
  line-height: 100%;
  font-weight: 500;
  margin: 1.2rem 0;
  color: #21042e;
  cursor: pointer;
}
.modules-section .title {
  font-size: 42px;
  line-height: 60px;
  font-weight: 600;
  margin: 1.2rem 0;
}

@media (min-width: 1700px) {
  .modules-section-container {
    max-width: 1440px;
  }
}

@media (min-width: 1280px) {
  .modules-section .content {
    margin: 0 3rem;
  }
}

.modules-section .business-content {
  width: 100%;
  margin: 2rem 0;
}
.modules-section .business-more {
  width: 280px;
}
.modules-section .business {
  width: 120px;
  height: 50px;

  color: #21042e;
  background-color: #fff;
  border-radius: 50px;
  border: #f5f5f5 1px solid;

  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  cursor: pointer;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}
.business:hover, .business:focus {
  text-decoration: none;
  outline: none;
  border: none;
}
.modules-section .business-selected {
  background: linear-gradient(to right, 
    #d054aa 0%, 
    #5a0a7e 100%);
  color: #fff;
  font-weight: 500;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.business-body {
  font-size: 18px;
  line-height: 26px;
  font-weight: 400;
}
.business-body-title {
  width: 100%;
  height: 60px;
  color: #fff;
  background: linear-gradient(to right, 
    #d054aa 0%, 
    #5a0a7e 100%);
  font-size: 18px;
  line-height: 26px;
  font-weight: 500;
  border-radius: 10px;
  margin: 1.2rem 0;
}
.business-body-content {
  margin-bottom: 1.2rem;
}
.business-body-key {
  background-color: #f8f8f8;
  border-radius: 10px;
  border: #f5f5f5 1px solid;
  width: 100%;
  height: 100%;
}
.business-body-value {
  background-color: #f8f8f8;
  border-radius: 10px;
  border: #f5f5f5 1px solid;
  width: 100%;
  
}
.business-body-value-content {
  margin: 3rem;
}
.business-body-item-left {

}
.business-body-item-right {

}
.business-body-item {

}
.business-body-item-icon {
  margin-left: 0.4rem;
}

.modules-section .pos-content {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 4.5rem 0 2rem 0;
}

.modules-section .subtitle {
  font-size: 18px;
  line-height: 100%;
  color: #bc68a4;
}
.modules-section .pos-img {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
}
.modules-section .pos-img-bg {
  background-image: url('/static/pos_bg.png');
  background-position: center;  
  background-size: cover;      
  background-repeat: no-repeat;
  width: 186px;
  height: 320px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.modules-section .content-row {
  margin: 40px 0;
}



</style>


// WEBPACK FOOTER //
// src/views/MerchantCase.vue